export default __webpack_public_path__ + "images/TX.26a4fa5.png";